export const PROFITABILITY_INDEXER = {
    Ipca: "IPCA",
    Igpm: "IGP-M",
    Selic: "SELIC",
    Cdi: "CDI",
    CdiPlus: "CDI +",
    Pre: "PRE"
};
